<h1 mat-dialog-title>
  {{ model.header }}
</h1>
<mat-dialog-content class="mat-typography">
  <p>
    {{ model.message }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="close()">
    {{ model.rejectLabel }}
  </button>
  <button mat-raised-button class="default-button-color" [disabled]="model.acceptDisabled" (click)="confirm()">
    {{ model.acceptLabel }}
  </button>
</mat-dialog-actions>
